/**
 * Where a bill stands, counted by the bill's own status (AB#6872). One rule for the
 * dashboard, the Bills screens and the server's distributions pipeline
 * (GET /Bills/distributions), so a count always matches the rows it filters.
 *
 * PURE module: no React, MUI, axios or auth imports.
 */

export type BillBucket = "paid" | "sent" | "notSent" | "failed" | "other";

const lower = (value?: string | null): string =>
  (value ?? "").trim().toLowerCase();

/**
 * Bill status wins; payment status is only read when the bill status is empty (legacy rows).
 *
 *   status empty: paid|processed|completed -> paid; failed|error -> failed;
 *                 unpaid|new|pending|'' -> notSent; anything else -> other
 *   otherwise:    paid -> paid; failed|error -> failed; new -> notSent;
 *                 pendingpayment|sent -> sent; anything else -> other
 */
export function bucketFor(
  status?: string | null,
  paymentStatus?: string | null
): BillBucket {
  const s = lower(status);
  if (s === "") {
    switch (lower(paymentStatus)) {
      case "paid":
      case "processed":
      case "completed":
        return "paid";
      case "failed":
      case "error":
        return "failed";
      case "unpaid":
      case "new":
      case "pending":
      case "":
        return "notSent";
      default:
        return "other";
    }
  }
  switch (s) {
    case "paid":
      return "paid";
    case "failed":
    case "error":
      return "failed";
    case "new":
      return "notSent";
    case "pendingpayment":
    case "sent":
      return "sent";
    default:
      return "other";
  }
}
